import api from "../../index";

export const GetAdminDashboardApi = () => api.post('admin-dashboard');
export const GetEmployeeDashboardApi = () => api.post('employee-dashboard');